<template>
<w-setting-sliding-popup ref="slidingPopup" title="프로세스 ID 변경" @close="closePopup">
  <div slot="content">
    <el-table-wrapper :data="dataList" :columns="duplicateColumns" :column-default="columnDefault" :pagination="false" :show-custom-header="false" style="width:100%;">
      <template slot-scope="scope" slot="processIdInput">
          <el-input v-model="scope.row.processId" placeholder="입력해 주세요."></el-input>
        </template>
    </el-table-wrapper>
    * 프로세스 ID가 중복된 리스트입니다. 프로세스 ID 수정 후 등록버튼을 눌러 주세요.
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" type="solid" class="mr-r4" @click="saveData">저장</el-button>
    <el-button size="large" @click="closePopup">취소</el-button>
  </el-row>
</w-setting-sliding-popup>
</template>

<script>
import { isUndefined, isNil, find, cloneDeep, clone } from 'lodash';
import { columnDefault } from '@/constants/table';
import ServerSettingAPI from '@/api/settings/server/server-settings';

export default {
  name: 'WDuplicateMajorProcPopup',
  props: {
    duplicateData: Array,
    saveDataList: Array,
  },
  data() {
    return {
      changeProcessList: null,
      dataList: null,
      compareList: null,
      columnDefault,
      duplicateColumns: [
        {
          prop: 'parentLabel',
          label: '장비명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processId',
          label: '프로세스 ID',
          scopedSlot: 'processIdInput',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processName',
          label: '프로세스명',
          showOverflowTooltip: true,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    duplicateData: {
      handler() {
        this.dataList = cloneDeep(this.duplicateData);
        this.compareList = clone(this.duplicateData);
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [closePopup 중복된 프로세스 ID가 있는 경우에도 팝업을 닫는 경우 중복된 ID를 제외한 나머지 프로세스를 등록한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    closePopup() {
      const exceptList = [];
      this.saveDataList.forEach((node) => {
        const selectedData = find(this.dataList, (item) => item.processId !== node.processId);
        if (!isUndefined(selectedData) && !isNil(selectedData)) {
          exceptList.push(selectedData);
        }
      });
      if (exceptList.length > 0) {
        ServerSettingAPI.insertMajorProcess(exceptList).then((result) => {
          if (result.data.success) {
            this.$emit('reload');
            this.$refs.slidingPopup.visible = false;
            this.$message({
              message: '중요 프로세스를 등록했습니다.',
              type: 'success',
            });
          }
        });
      } else {
        this.$emit('reload');
        this.$refs.slidingPopup.visible = false;
        this.$message({
          message: '중요 프로세스를 등록하지 못하였습니다.',
          type: 'error',
        });
      }
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    /**
     * [saveData 프로세스 아이디가 중복되는 경우 다시 한번 팝업을 통해 확인한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    saveData() {
      const changeProcessIdList = [];
      const me = this;
      // processId가 변경된 항목을 추려낸다.
      this.compareList.forEach((node) => {
        const findData = find(me.dataList, (item) => item.processId !== node.processId && item.processName !== node.processName);
        if (!isUndefined(findData) && !isNil(findData)) {
          changeProcessIdList.push(findData);
        }
      });
      this.changeProcessList = changeProcessIdList;
      const changeListCnt = changeProcessIdList.length;
      const dataListCnt = this.dataList.length;
      // 수정한 데이터가 기존 proceesId와 일치하지 않는 경우
      if (changeListCnt !== dataListCnt) {
        const nonChangeCnt = dataListCnt - changeListCnt;
        this.$confirm(`변경되지 않은 프로세스가 ${nonChangeCnt}건 있습니다. 등록을 진행하시겠습니까?`, 'Warning', {
          confirmButtonText: '등록',
          cancelButtonText: '취소',
          type: 'info',
        }).then(() => {
          // 변경된 프로세스 아이디가 있는 리스트를 저장한다.
          ServerSettingAPI.insertMajorProcess(this.changeProcessList).then((result) => {
            if (result.data.success) {
              this.$message({
                message: '중요 프로세스를 등록했습니다.',
                type: 'success',
              });
            }
          });
          this.$emit('reload');
          this.closePopup();
        }).catch(() => {
          // 동일 프로세스를 제거한 후 insert
          const exceptList = [];
          this.saveDataList.forEach((node) => {
            const selectedData = find(this.dataList, (item) => item.processId !== node.processId);
            exceptList.push(selectedData);
          });
          ServerSettingAPI.insertMajorProcess(exceptList).then((result) => {
            if (result.data.success) {
              this.$message({
                message: '중요 프로세스를 등록했습니다.',
                type: 'success',
              });
            }
          });
          this.$emit('reload');
          this.closePopup();
        });
      } else {
        // 수정한 데이터가 중복되는 processId가 없는 경우
        ServerSettingAPI.insertMajorProcess(this.changeProcessList).then((result) => {
          if (result.data.success) {
            this.$message({
              message: '중요 프로세스를 등록했습니다.',
              type: 'success',
            });
          }
        });
        this.$emit('reload');
        this.closePopup();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/popup/DuplicateMajorProcPopup.vue